/**
 * DescriptionHeroContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled description hero container.
 */
const DescriptionHeroContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: row;
  right: ${41 * Screen.widthRatio}px;
  top: ${54 * Screen.widthRatio}px;
  position: absolute;
`;

export default withOpacity(DescriptionHeroContainer);
